import { render, staticRenderFns } from "./new-user-guide.vue?vue&type=template&id=ac9bed70&scoped=true&"
import script from "./new-user-guide.vue?vue&type=script&lang=js&"
export * from "./new-user-guide.vue?vue&type=script&lang=js&"
import style0 from "./new-user-guide.vue?vue&type=style&index=0&id=ac9bed70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac9bed70",
  null
  
)

export default component.exports